// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__K18uN","col":"styles_col__20fBO"};